import { Allocation, Problem } from './types';

// Copia profunda de una matriz de asignación.
export function cloneAlloc(alloc: Allocation): Allocation {
  return alloc.map((row) => row.slice());
}

// Crea una matriz m x n llena de un valor dado.
export function makeMatrix<T>(m: number, n: number, value: T): T[][] {
  return Array.from({ length: m }, () => Array.from({ length: n }, () => value));
}

// Calcula el costo total de una asignación.
export function totalCost(alloc: Allocation, costs: number[][]): number {
  let sum = 0;
  for (let i = 0; i < alloc.length; i++) {
    for (let j = 0; j < alloc[i].length; j++) {
      const a = alloc[i][j];
      if (a !== null) sum += a * costs[i][j];
    }
  }
  return sum;
}

// Cuenta las celdas básicas (no nulas) de una asignación.
export function countBasic(alloc: Allocation): number {
  let c = 0;
  for (const row of alloc) for (const v of row) if (v !== null) c++;
  return c;
}

// Balancea el problema agregando un origen o destino ficticio (dummy) si la
// oferta total no coincide con la demanda total. Devuelve el problema balanceado
// y una nota descriptiva (o null si ya estaba balanceado).
export function balanceProblem(p: Problem): { problem: Problem; note: string | null } {
  const totalSupply = p.supply.reduce((a, b) => a + b, 0);
  const totalDemand = p.demand.reduce((a, b) => a + b, 0);

  if (totalSupply === totalDemand) {
    return { problem: p, note: null };
  }

  const costs = p.costs.map((row) => row.slice());
  const supply = p.supply.slice();
  const demand = p.demand.slice();
  const sources = p.sources.slice();
  const dests = p.dests.slice();

  if (totalSupply > totalDemand) {
    // Falta demanda -> destino ficticio con costo 0
    const diff = totalSupply - totalDemand;
    for (let i = 0; i < costs.length; i++) costs[i] = [...costs[i], 0];
    demand.push(diff);
    dests.push('Ficticio');
    return {
      problem: { costs, supply, demand, sources, dests },
      note: `Oferta (${totalSupply}) > Demanda (${totalDemand}). Se agregó un destino ficticio con demanda ${diff} y costos 0.`,
    };
  } else {
    // Falta oferta -> origen ficticio con costo 0
    const diff = totalDemand - totalSupply;
    costs.push(new Array(demand.length).fill(0));
    supply.push(diff);
    sources.push('Ficticio');
    return {
      problem: { costs, supply, demand, sources, dests },
      note: `Demanda (${totalDemand}) > Oferta (${totalSupply}). Se agregó un origen ficticio con oferta ${diff} y costos 0.`,
    };
  }
}
